module.exports = __webpack_public_path__ + "img/5.61b296dd.jpg";